import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const MAX_TEXT_WIDTH = {
  [HD]: 1000,
  [FULL_HD]: 1000,
};

export const TITLE_MARGIN_BOTTOM = {
  [HD]: 4,
  [FULL_HD]: 8,
};
